/** Opções de filtro da listagem de organizações (fonte única UI + labels). */

export type AdminFilterOption = { value: string; label: string };

export const ORG_STATUS_BUCKET_FILTERS: AdminFilterOption[] = [
  { value: 'active', label: 'Ativo' },
  { value: 'trial', label: 'Trial' },
  { value: 'past_due', label: 'Inadimplente' },
  { value: 'blocked', label: 'Bloqueado' },
  { value: 'canceled', label: 'Cancelado' },
];

export const ORG_PLAN_FILTERS: AdminFilterOption[] = [
  { value: 'basic', label: 'Basic' },
  { value: 'pro', label: 'Pro' },
  { value: 'enterprise', label: 'Enterprise' },
];

export const ORG_SORT_FILTERS: AdminFilterOption[] = [
  { value: 'recent', label: 'Mais recentes' },
  { value: 'name_asc', label: 'Nome (A–Z)' },
  { value: 'name_desc', label: 'Nome (Z–A)' },
  { value: 'mrr_desc', label: 'Maior MRR' },
];

/** @deprecated use ORG_STATUS_BUCKET_FILTERS */
export const ORG_STATUS_FILTERS = ORG_STATUS_BUCKET_FILTERS;

/** @deprecated subscription filter removed from list toolbar */
export const ORG_SUBSCRIPTION_FILTERS: AdminFilterOption[] = [
  { value: 'trialing', label: 'Trialing' },
  { value: 'active', label: 'Active' },
  { value: 'past_due', label: 'Past due' },
  { value: 'blocked', label: 'Blocked' },
  { value: 'canceled', label: 'Canceled' },
];

export type AdminOrganizationFilters = {
  statusBucket: string;
  plan: string;
  sort: string;
};

export const EMPTY_ORG_FILTERS: AdminOrganizationFilters = {
  statusBucket: '',
  plan: '',
  sort: 'recent',
};
